import {
  Button,
  Card,
  Col,
  message,
  Row,
  Table,
  Input,
  Modal,
  Tag,
  Select,
} from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import React, { useEffect, useState, useCallback } from "react";
import { useHistory, withRouter } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { strings } from "res";
import { fetchAllUser, deleteUser } from "redux/features/user";
import moment from "moment";

const LocalizedModal = () => {
  const [open, setOpen] = useState(false);
  const showModal = () => {
    setOpen(true);
  };
  const hideModal = () => {
    setOpen(false);
  };
  return (
    <>
      <Modal
        title="Modal"
        open={open}
        onOk={hideModal}
        onCancel={hideModal}
        okText="Ok"
        cancelText="Cancel"
      >
        <p>Bla bla ...</p>
        <p>Bla bla ...</p>
        <p>Bla bla ...</p>
      </Modal>
    </>
  );
};

export const USERS = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(true);
  const [data, setData] = useState();
  const [modal, contextHolder] = Modal.useModal();

  const [filters, setFilters] = useState({
    page: 1,
    limit: 10,
    sort: "created_at",
    total_data: 0,
  });

  const { Search } = Input;
  console.log(data);

  const roleColorMap = {
    protocol: "red",
    dewan: "blue",
    operator: "green",
  };

  const tableColumns = [
    {
      title: "No",
      key: "no",
      render: (_text, _record, index) =>
        (filters.page - 1) * filters.limit + index + 1,
    },
    // {
    //   title: "Id",
    //   dataIndex: "id",
    //   key: "id",
    // },
    {
      title: "Role",
      dataIndex: "role",
      key: "role",
      render: (role) => {
        const color = roleColorMap[role?.name?.toLowerCase()] || "default";
        return role ? <Tag color={color}>{role.name}</Tag> : "-";
      },
    },
    {
      title: "Username",
      dataIndex: "username",
      key: "username",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Status Akun",
      dataIndex: "isActive",
      key: "isActive",
      render: (_, record) => (
        <div className="text-center">{record ? "Aktif" : "Tidak Aktif"}</div>
      ),
    },
    {
      title: () => <div className="text-center">Detail</div>,
      key: "status",
      render: (_, record) => (
        <div className="text-center">
          <Button
            type="primary"
            style={{ textAlign: "center" }}
            onClick={() => {
              history.push({
                pathname: `${strings.navigation.path.detail_user}`,
                state: record,
              });
            }}
          >
            Detail
          </Button>
        </div>
      ),
    },
    {
      title: () => <div className="text-center">Action</div>,
      key: "status",
      render: (_, record) => (
        <div className="text-center">
          <Button
            type="danger"
            style={{ textAlign: "center", color: "white" }}
            onClick={() => {
              confirm(record.id);
            }}
          >
            Delete
          </Button>
        </div>
      ),
    },
  ];

  const getData = async (params) => {
    try {
      const response = await dispatch(fetchAllUser(params)).unwrap();
      setData(response.data);
      setLoading(false);
    } catch (error) {
      message.error(error?.message || "Failed to fetch data");
    }
  };

  const confirm = (id) => {
    modal.confirm({
      title: "Are you sure?",
      icon: <ExclamationCircleOutlined />,
      content: "Are you sure wanna delete this?",
      okText: "Yes",
      cancelText: "No",
      onOk: async () => {
        await dispatch(deleteUser(id));
        getData();
      },
      onCancel: () => {},
    });
  };

  const handleSearchByTitle = (event) => {
    setFilters({
      ...filters,
      username: event.target.value ? event.target.value : undefined,
    });
  };

  useEffect(() => {
    getData(filters);
  }, [filters]);

  const roleOptions = [
    { label: "Protocol", value: "protocol" },
    { label: "Dewan", value: "dewan" },
    { label: "Operator", value: "operator" },
  ];

  const handleSearchByRole = (event) => {
    setFilters({
      ...filters,
      role: event ? event : undefined,
    });
  };

  return (
    <>
      <LocalizedModal></LocalizedModal>
      <Row gutter={24}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <h2>Pengguna</h2>
          <p>Daftar semua pengguna</p>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <Card>
            <Row gutter={[16, 2]}>
              <Col xs={24} sm={24} md={18} lg={18}>
                <Input
                  placeholder="Search By Username"
                  onSelect={handleSearchByTitle}
                  allowClear
                  style={{ width: "100%" }}
                ></Input>
              </Col>
              <Col xs={24} sm={24} md={6} lg={6}>
                <Select
                  placeholder="Search By Role"
                  options={roleOptions}
                  onSelect={handleSearchByRole}
                  allowClear
                  onClear={handleSearchByRole}
                  style={{ width: "100%" }}
                ></Select>
              </Col>
            </Row>

            <Table
              className="no-border-last"
              style={{ textAlign: "center", margin: "auto" }}
              scroll={{ x: "100%" }}
              columns={tableColumns}
              dataSource={data}
              rowKey="id"
              loading={isLoading}
              pagination={false}
            />
          </Card>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <Button
            type="primary"
            style={{ border: "0px" }}
            htmlType="submit"
            onClick={() => {
              history.push({
                pathname: `${strings.navigation.path.detail_user}`,
              });
            }}
            block
          >
            Tambah Pengguna
          </Button>
        </Col>
      </Row>
      {contextHolder}
    </>
  );
};

export default withRouter(USERS);
